/**
 * Questions (Engine) feature hooks — React Query wrappers for CRUD operations.
 */
import { useMutation, useQuery, useQueryClient, keepPreviousData } from '@tanstack/react-query'
import { engineQuestionsApi } from './api'

export function useEngineQuestions(params?: any) {
    return useQuery({
        queryKey: ['questions', params],
        queryFn: async () => {
            const res = await engineQuestionsApi.getAll(params)
            return res.data
        },
        placeholderData: keepPreviousData,
    })
}

export function useCreateEngineQuestion() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (data: any) => engineQuestionsApi.create(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['questions'] })
        },
    })
}

export function useUpdateEngineQuestion() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: any }) => engineQuestionsApi.update(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['questions'] })
        },
    })
}

export function useDeleteEngineQuestion() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (id: string) => engineQuestionsApi.delete(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['questions'] })
        },
    })
}

